import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [isRecovery, setIsRecovery] = useState(false);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash.includes("type=recovery")) {
      setIsRecovery(true);
    }
    supabase.auth.onAuthStateChange((event) => {
      if (event === "PASSWORD_RECOVERY") {
        setIsRecovery(true);
      }
    });
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirm) { setError("Las contraseñas no coinciden / Passwords don't match"); return; }
    if (password.length < 6) { setError("Mínimo 6 caracteres / Min 6 characters"); return; }
    setSubmitting(true);
    setError("");
    const { error } = await supabase.auth.updateUser({ password });
    if (error) { setError(error.message); setSubmitting(false); return; }
    setSuccess(true);
    setTimeout(() => navigate("/"), 2000);
  };

  if (!isRecovery) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Nunito Sans',system-ui,sans-serif", background: "#FFFBF5" }}>
        <p>Invalid or expired recovery link.</p>
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "linear-gradient(135deg,#0E3B26,#1A7A52 35%,#26A69A 65%,#FF8A65 95%)", padding: 20, fontFamily: "'Nunito Sans',system-ui,sans-serif" }}>
      <div style={{ background: "#fff", borderRadius: 24, padding: "40px 32px", width: "100%", maxWidth: 400, boxShadow: "0 12px 40px rgba(0,0,0,.15)" }}>
        <div style={{ fontFamily: "'Fraunces',Georgia,serif", fontSize: 19, fontWeight: 700, marginBottom: 22 }}>
          🌿 Nutri<span style={{ color: "#1A7A52" }}>Mart</span>
        </div>
        <h1 style={{ fontFamily: "'Fraunces',Georgia,serif", fontSize: 24, fontWeight: 700, marginBottom: 8 }}>
          Nueva Contraseña
        </h1>
        {success ? (
          <p style={{ color: "#065F46", fontSize: 13 }}>¡Contraseña actualizada! Redirigiendo...</p>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && <div style={{ background: "#FEE2E2", color: "#DC2626", padding: "8px 12px", borderRadius: 8, fontSize: 12, marginBottom: 12 }}>{error}</div>}
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: "block", fontSize: 10.5, fontWeight: 600, color: "#5A5A56", marginBottom: 4, textTransform: "uppercase" }}>Nueva Contraseña</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} required minLength={6}
                style={{ width: "100%", padding: "9px 12px", border: "1.5px solid #E8E2D8", borderRadius: 8, fontSize: 13, outline: "none" }} />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: "block", fontSize: 10.5, fontWeight: 600, color: "#5A5A56", marginBottom: 4, textTransform: "uppercase" }}>Confirmar Contraseña</label>
              <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required minLength={6}
                style={{ width: "100%", padding: "9px 12px", border: "1.5px solid #E8E2D8", borderRadius: 8, fontSize: 13, outline: "none" }} />
            </div>
            <button type="submit" disabled={submitting} style={{
              width: "100%", padding: "10px 20px", borderRadius: 12, fontSize: 13, fontWeight: 600,
              cursor: "pointer", border: "none", color: "#fff", background: "linear-gradient(135deg,#1A7A52,#26A69A)",
              boxShadow: "0 2px 8px rgba(26,122,82,.25)", opacity: submitting ? .7 : 1,
            }}>
              {submitting ? "..." : "Actualizar Contraseña →"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
